module.exports = __webpack_public_path__ + "img/spiritcatcher-2.a050cbeb.jpg";